import { render, staticRenderFns } from "./CreateConcept.vue?vue&type=template&id=2197ad18&scoped=true&"
import script from "./CreateConcept.vue?vue&type=script&lang=ts&"
export * from "./CreateConcept.vue?vue&type=script&lang=ts&"
import style0 from "./CreateConcept.vue?vue&type=style&index=0&id=2197ad18&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2197ad18",
  null
  
)

export default component.exports